import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { GlobalConstants } from './global-constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileImageService {

  constructor() { }

  private image!: string;
  private valueSubject: Subject<string> = new Subject<string>();

  setImage(newValue: string) {
    this.image = GlobalConstants.staticFilesURL + newValue;
    this.valueSubject.next(this.image);
  }

  getImage(): Observable<string> {
    return this.valueSubject.asObservable();
  }
}
